<template>
  <div
    ref="frisbuy-widget-stories"
    :class="{
      'frisbuy-sr-widget': true,
      'frisbuy-has-selected': selectedStory,
      'frisbuy-sr-right': settings.widget.rightSide == 1,
      'frisbuy-sr-mobile-fixed': settings.widget.mobileFixed == 1,
      'frisbuy-sr-inline': isInline,
      'frisbuy-mobile-only': isMobileOnly,
      'frisbuy-desktop-only': isDesktopOnly,
    }"
    :style="{
      paddingTop: paddings.top,
      paddingBottom: paddings.bottom,
      paddingLeft: paddings.left,
      paddingRight: paddings.right,
      backgroundColor: backgroundColor,
    }"
  >
    <div v-if="settings.customStyles" v-html="settings.customStyles"></div>
    <div
      v-if="settings.widget.html"
      class="frisbuy-title-block"
      v-html="settings.widget.html"
    ></div>
    <div :class="{ 'frisbuy-sr-block-wrapper': isArrowsDisplayed }">
      <div v-if="isArrowsDisplayed">
        <FrisbuySrArrow
          v-show="isScrollLeft"
          @click="slideHandler(-1)"
          direction="left"
        />
        <FrisbuySrArrow @click="slideHandler(1)" direction="right" />
      </div>
      <FrisbuySrBlock
        @selectStory="selectStory"
        :stories="stories"
        :selectedStory="selectedStory"
        :visited="visited"
        :isInline="isInline"
        :isSeenBrandLogo="!settings.widget.hideBrand"
      />
    </div>
    <StoriesPreview
      :settings="settings"
      :story="selectedStory"
      :stories="stories"
      @set-story="selectStory"
      @close-preview="closePreview"
    />
  </div>
</template>

<script>
// TODO: remove "body-scroll-lock" lib from project. Use func `lockWindowScroll` to block page scrolling
import { clearAllBodyScrollLocks } from "body-scroll-lock";
import StoriesPreview from "./StoriesPreview.vue";
import analytics from "../common/mixins/analytics";
import elementInView from "../common/mixins/elementInView";
import FrisbuySrArrow from "./components/widget/FrisbuySrArrow.vue";
import FrisbuySrBlock from "./components/widget/FrisbuySrBlock.vue";
import {
  deleteParamFromHash,
  getValueFromHashParam,
  setHashParam,
} from "@/services/urlHashParam";

export default {
  provide() {
    return {
      settings: this.settings,
      sendAnalyticEvent: this.sendAnalyticEvent,
      isMobileLandscape: this.isMobileLandscape,
    };
  },

  components: {
    StoriesPreview,
    FrisbuySrArrow,
    FrisbuySrBlock,
  },

  data() {
    return {
      settings: this.propSettings || {},
      selectedStory: null,
      hadSeen: false,
      visited: JSON.parse(localStorage.getItem("visited") || "[]"),
      labelItemPosition: [
        "fbProduct",
        "igCode",
        "link",
        "linklabel",
        "offer",
        "swipeType",
      ],
      categoryPostfix: "SR",
      isArrowsDisplayed:
        this.propSettings.widget.showScrollArrows == 1 &&
        window.innerWidth > 459,
      isMobileLandscape: false,
      isScrollLeft: false,
    };
  },

  mixins: [analytics, elementInView],

  props: ["propSettings", "stories"],

  beforeMount() {
    const { script: scriptCode } = this.settings.widget;

    if (scriptCode) {
      const head = document.querySelector("head");
      const script = document.createElement("script");

      script.type = "text/javascript";

      try {
        script.appendChild(document.createTextNode(scriptCode));
      } catch (e) {
        script.text = scriptCode;
      }

      head.insertBefore(script, head.firstChild);
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.selectPostByLinkHash();
    });

    const scrollElement =
      this.widgetRefElement.querySelector(".frisbuy-sr-block");

    this.isScrollLeft = scrollElement.scrollLeft !== 0;

    this.scrollHandler();
    window.addEventListener("scroll", this.scrollHandler);
    window.addEventListener("message", this.postMessageHandler);

    (function (timer) {
      const scrollElement = document.querySelector(".frisbuy-sr-block");
      scrollElement.addEventListener("scroll", () => {
        (function (el) {
          el.classList.add("frisbuy-is-scrolling");
          clearTimeout(timer);
          timer = setTimeout(function () {
            el.classList.remove("frisbuy-is-scrolling");
          }, 100);
        })(scrollElement);
      });
    })();
  },

  created() {
    this.sendAnalyticEvent("Load", location.href, true, true);
    window.addEventListener("resize", this.handleViewportResize);
    window.addEventListener("hashchange", this.selectPostByLinkHash);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleViewportResize);
    window.removeEventListener("message", this.postMessageHandler);
    window.removeEventListener("hashchange", this.selectPostByLinkHash);
  },

  methods: {
    setStoryToHashParams(albumId, postIndex = undefined) {
      if (
        this.settings["popup_update_url"] &&
        this.settings["popup_update_url"] === "0"
      ) {
        return;
      }

      const hashName = "fri_prov_story_id";

      const storyHashValue = postIndex
        ? `${albumId}-${postIndex}`
        : String(albumId);

      setHashParam(hashName, storyHashValue);
    },

    selectPostByLinkHash() {
      const hashName = "fri_prov_story_id";
      const hashValue = getValueFromHashParam(hashName);

      if (hashValue) {
        const albumId = Number(hashValue.split("-")[0]);
        // const postIndex = Number(hashValue.split("-")[1] || 0);
        const albumByIndex = this.stories.find(
          (album) =>
            album.instagramPost?.frisbuyId === albumId ||
            album.providerPost?.frisbuyId === albumId
        );

        if (albumByIndex) {
          this.selectStory(albumByIndex);
          return;
        }
      }

      // NOTE: legacy supporting
      const hashNameLegacy = "fri_story_id";
      const hashValueLegacy = getValueFromHashParam(hashNameLegacy);

      if (hashValueLegacy) {
        const albumIdLegacy = Number(hashValueLegacy.split("-")[0]);
        // const postIndex = Number(hashValue.split("-")[1] || 0);
        const albumByIndexLegacy = this.stories.find(
          (album) => album.frisbuyPost.id === albumIdLegacy
        );

        if (albumByIndexLegacy) {
          console.warn(
            `Please do not use legacy '${hashNameLegacy}' hash param`
          );
          this.selectStory(albumByIndexLegacy);
          return;
        }
      }
    },

    selectStory(story, event) {
      const { visited } = this;

      const { frisbuyId } = story.instagramPost;

      this.selectedStory = story;

      this.setStoryToHashParams(
        story.instagramPost?.frisbuyId || story.providerPost.frisbuyId
      );

      const hashNameLegacy = "fri_story_id";
      deleteParamFromHash(hashNameLegacy);

      if (event) {
        this.sendAnalyticEvent("ClickPic", {
          provPostId:
            story.instagramPost?.frisbuyId ?? story.providerPost.frisbuyId,
          fbProduct: story.frisbuyPost.id,
          igCode: story.instagramPost.shortcode,
        });
      }

      this.sendAnalyticEvent("ViewPic", {
        provPostId:
          story.instagramPost?.frisbuyId ?? story.providerPost.frisbuyId,
        fbProduct: story.frisbuyPost.id,
        igCode: story.instagramPost.shortcode,
      });

      if (visited.includes(frisbuyId)) return;

      visited.push(frisbuyId);

      localStorage.setItem("visited", JSON.stringify(visited));
    },

    closePreview() {
      this.selectedStory = null;
      clearAllBodyScrollLocks();
    },

    scrollHandler() {
      this.$nextTick(() => {
        const { isElementInView, sendAnalyticEvent, hadSeen, $el } = this;

        if (!hadSeen && isElementInView($el, true)) {
          this.hadSeen = true;
          sendAnalyticEvent("Eyesight", location.href, true, true);
        }
      });
    },

    slideHandler(direction) {
      const scrollElement =
        this.widgetRefElement.querySelector(".frisbuy-sr-block");
      const widthElement =
        this.widgetRefElement.querySelectorAll(".frisbuy-sr-story")[1];

      scrollElement.scrollBy = (elementWidth) => {
        scrollElement.scrollLeft += elementWidth;
      };

      scrollElement.scrollBy(widthElement.clientWidth * direction, 0);

      const showArrowPx = 15;
      const moveToPx =
        scrollElement.scrollLeft + widthElement.clientWidth * direction;

      this.isScrollLeft = moveToPx > showArrowPx;
    },

    handleViewportResize() {
      this.isMobileLandscape = false;

      if (window.innerWidth > 479 && window.innerHeight < 416) {
        this.isMobileLandscape = true;
      }

      if (
        this.settings.widget.showScrollArrows == 1 &&
        window.innerWidth > 459
      ) {
        this.isArrowsDisplayed = true;
      } else {
        this.isArrowsDisplayed = false;
      }
    },

    updateSettings(path, value) {
      const nodes = path.split(".");
      const settingsType = nodes.shift();
      const lastNode = nodes[nodes.length - 1];

      let source = nodes.reduce((source, node) => {
        if (node === lastNode) return source;

        if (!source || !Object.hasOwn(source, node)) return;
        return source[node];
      }, this[settingsType]);

      if (!source) return console.error("Can't find source by path.");

      source[lastNode] = value;
    },

    postMessageHandler(event) {
      const { data } = event;

      if (
        !event.origin.includes("frisbuy") ||
        !data ||
        !Object.hasOwn(data, "property")
      )
        return;

      this.$nextTick(() => {
        this.updateSettings(data.property, data.value);
      });
    },
  },

  computed: {
    widgetRefElement() {
      return this.$refs["frisbuy-widget-stories"];
    },

    isInline() {
      return (
        this.settings.widget.inlineDesktop == 1 ||
        (this.isMobileLandscape && !this.settings.widget.mobileFixed)
      );
    },

    paddings() {
      const { widget } = this.settings;

      if (this.isInline) {
        if (widget.paddings) {
          return widget.paddings;
        }
      }

      return {
        top: undefined,
        bottom: undefined,
        left: undefined,
        right: undefined,
      };
    },

    backgroundColor() {
      const { widget } = this.settings;

      if (this.isInline) {
        if (widget.backgroundColor) {
          return widget.backgroundColor;
        }
      }

      return undefined;
    },

    isMobileOnly() {
      return (
        (this.settings.mobileOnly == 1 ||
          typeof this.settings.mobileOnly === "undefined") &&
        this.settings.desktopOnly === 0
      );
    },

    isDesktopOnly() {
      return (
        (this.settings.desktopOnly == 1 ||
          typeof this.settings.desktopOnly === "undefined") &&
        this.settings.mobileOnly === 0
      );
    },
  },

  watch: {
    selectedStory(album) {
      if (!album) {
        const hashName = "fri_prov_story_id";
        deleteParamFromHash(hashName);

        const hashNameLegacy = "fri_story_id";
        deleteParamFromHash(hashNameLegacy);
      }
    },
  },
};
</script>

<style lang="scss">
@import "../common/style/mixins.scss";

@keyframes slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slide-reverse {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes story-slide {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(49px);
  }
}

@keyframes story-slide-reverse {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-49px);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  15% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.frisbuy-sr-widget {
  font-family: "Gotham Pro", sans-serif;
  border-radius: 0 16px 16px 0;
  height: 512px;
  position: fixed;
  left: 0;
  width: 80px;
  top: calc(50% - 256px);
  box-sizing: border-box;
  display: flex;
  transition: width 1s, 1s height 1s, 1s top 1s;
  z-index: 9999999999999;
  transform: translateX(-100%);
  animation: 1s slide forwards;

  .frisbuy-title-block {
    display: none;
  }

  &.frisbuy-sr-right {
    left: auto;
    right: 0;
    transform: translateX(0);
    border-radius: 16px 0 0 16px;
    animation: 1s slide-reverse forwards;

    .frisbuy-sr-block {
      border-radius: 16px 0 0 16px;
    }

    .frisbuy-sr-story-wrapper {
      &.frisbuy-sr-selected {
        &:before {
          content: "";
          border-width: 5px 5px 5px 0;
          border-color: transparent #222222 transparent transparent;
          left: auto;
          right: 100%;
        }
      }
    }
  }

  &.frisbuy-has-selected {
    height: 656px;
    top: calc(50% - 328px);
    transition: height 1s, top 1s, 1s width 1s;

    .frisbuy-sr-block {
      border-radius: 0;
      box-shadow: none;
      transition: 2s box-shadow 0s;
    }
  }

  &.frisbuy-sr-inline {
    position: static;
    box-shadow: none;
    border-radius: 0;
    width: 100%;
    display: block !important;
    max-width: 100%;
    height: auto;
    animation: none;
    transform: none;

    &.frisbuy-has-selected {
      height: auto;
      width: auto;
      transition: none;
      animation: none;
    }

    .frisbuy-title-block {
      display: block;
    }

    .frisbuy-sr-block {
      flex-direction: row;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      background-color: transparent;
      box-shadow: none;
      scroll-behavior: smooth;

      &-wrapper {
        position: relative;

        .frisbuy-sr-block {
          overflow-x: hidden;
        }

        .frisbuy-sr-arrow {
          position: absolute;
          z-index: 3;
          height: 100%;
          display: flex;
          align-items: center;
          padding-bottom: 15px;
          overflow: scroll;
        }
      }

      &.frisbuy-is-scrolling {
        &::-webkit-scrollbar-thumb {
          background: #717171;
        }
      }

      &::-webkit-scrollbar {
        width: 2px;
        height: 3px;
      }
      &::-webkit-scrollbar-button {
        width: 0;
        height: 0;
      }
      &::-webkit-scrollbar-thumb {
        border: 0px none transparent;
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb:hover,
      .frisbuy-widget
        .frisbuy-gallery
        .frisbuy-scroll-wrapper::-webkit-scrollbar-thumb:active {
        background: #222222;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
        border: none;
      }
      &::-webkit-scrollbar-track:hover,
      .frisbuy-widget
        .frisbuy-gallery
        .frisbuy-scroll-wrapper::-webkit-scrollbar-track:active,
      .frisbuy-widget
        .frisbuy-gallery
        .frisbuy-scroll-wrapper::-webkit-scrollbar-corner {
        background: transparent;
      }

      .frisbuy-sr-branding {
        display: none;
      }
    }

    .frisbuy-sr-stories {
      display: flex;
      overflow: visible;
      justify-content: center;
    }

    .frisbuy-sr-story {
      padding-top: 0;

      &:not(:first-child) {
        padding-left: 8px;
      }

      &:last-child {
        margin: 0 !important;
      }
    }
  }

  * {
    box-sizing: border-box;
  }

  .frisbuy-sr-story {
    padding-top: 8px;

    &:first-child .frisbuy-sr-story-wrapper {
      position: relative;

      &.frisbuy-story-square {
        &:after {
          content: initial !important;
        }
      }

      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACaSURBVHgB7dJBDcMwEETRdREUQsqgEMKkLZIWQhkUSiEEQiiEgbOR1pIT5ZaLR/lPsiz7NBqNGY7JOXemxkM//Yx+HqYkQmep4NH2Yqzev+ans52JVPulXb/fm/Z7lfb/EbyPd2n/Y62rQq/al+GBhwh+X6YS7XemYGcyX1NRT8bPtfxfrH23uF8ppcmUlMkAAAAAAAAAAHB2MwGEt//dwcuSAAAAAElFTkSuQmCC");
        background-position: center;
        background-size: contain;
        border-radius: 100%;
        transform-origin: 50% 50%;
        animation: 6.5s spin 2s infinite;
      }
    }
  }

  @include screen-xs {
    &:not(.frisbuy-sr-mobile-fixed) {
      position: static;
      box-shadow: none;
      border-radius: 0;
      width: 100%;
      display: block;
      max-width: 100%;
      height: auto;
      animation: none;
      transform: none;

      &.frisbuy-has-selected {
        height: auto;
        width: auto;
        transition: none;
        animation: none;
      }

      .frisbuy-title-block {
        display: block;
      }

      .frisbuy-sr-block {
        flex-direction: row;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        background-color: transparent;
        box-shadow: none;
      }

      .frisbuy-sr-navigation-button,
      .frisbuy-sr-instagram {
        display: none;
      }

      .frisbuy-sr-stories {
        display: flex;
        overflow: visible;
      }

      .frisbuy-sr-story {
        padding-top: 0;

        &:not(:first-child) {
          padding-left: 8px;
        }
      }
    }

    &.frisbuy-sr-mobile-fixed {
      bottom: 50px;
      top: auto;
      height: 56px;
      width: 74px;

      &.frisbuy-sr-right {
        border-radius: 56px 0 0 56px;

        .frisbuy-sr-block {
          border-radius: 56px 0 0 56px;
          flex-direction: row;
          overflow: hidden;
        }

        .frisbuy-sr-stories {
          flex-direction: row;
          flex-shrink: 0;
          animation: 1s story-slide-reverse 1s forwards;
          margin-left: 0;
        }

        .frisbuy-sr-story {
          padding: 0 7px 0 0;
        }

        .frisbuy-sr-instagram {
          animation: 1s story-slide-reverse 1s forwards;
        }
      }

      &.frisbuy-has-selected {
        height: auto;
        width: auto;
        transition: none;
        transform: none;
        animation: none;
      }

      .frisbuy-sr-navigation-button {
        display: none;
      }

      .frisbuy-sr-instagram {
        position: static;
        flex-shrink: 0;
        height: 56px;
        animation: 1s story-slide 1s forwards;

        svg {
          height: 56px;
          width: 56px;
        }
      }

      .frisbuy-sr-block {
        display: flex;
        flex-direction: row-reverse;
        // align-items: center;
        // justify-content: center;
        overflow: hidden;
        padding: 0;
        height: 56px;
        width: 74px;
        max-width: 74px;
        border-radius: 0 56px 56px 0;
        transition: none;
      }

      .frisbuy-sr-stories {
        display: flex;
        flex-direction: row-reverse;
        width: 74px;
        margin-left: -49px;
        padding: 0;
        animation: 1s story-slide 1s forwards;
      }

      .frisbuy-sr-story {
        padding: 0 0 0 7px;

        &:first-child .frisbuy-sr-story-wrapper {
          &:after {
            width: 46px;
            height: 46px;
          }
        }
      }

      .frisbuy-sr-story-wrapper {
        width: 46px;
        height: 46px;
      }

      .frisbuy-preview-story {
        transition: unset;

        &:before {
          display: none;
        }
      }
    }
  }

  @media (max-height: 700px) and (min-width: 768px) {
    height: 448px;
    width: 80px;
    top: calc(50% - 224px);

    &.frisbuy-has-selected {
      height: 574px;
      top: calc(50% - 287px);
    }

    .frisbuy-sr-instagram {
      top: 7px;
      left: 7px;
      width: 56px;
      height: 56px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .frisbuy-sr-navigation-button {
      width: 56px;
      height: 56px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .frisbuy-sr-story {
      padding-top: 7px;
    }
  }

  &.frisbuy-mobile-only {
    @media screen and (min-width: 768px) {
      display: none !important;
    }
  }

  &.frisbuy-desktop-only {
    @media screen and (max-width: 768px) {
      display: none !important;
    }
  }
}
</style>
